import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup, { IDefaultPopupCustomStyles } from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { ImportSquare } from '@r1-frontend/ui-react/components/svg/arrows';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { FullWidthListContainer, IndentContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import DesktopBanner from '~/static/images/payments-abn/mobile-app-popup/desktop-banner.png';
import DesktopBannerWebp from '~/static/images/payments-abn/mobile-app-popup/desktop-banner.webp';
import MobileBanner from '~/static/images/payments-abn/mobile-app-popup/mobile-banner.png';
import MobileBannerWebp from '~/static/images/payments-abn/mobile-app-popup/mobile-banner.webp';

import { mobileAppPopupAnalytics } from './analytics';

const customStyles: IDefaultPopupCustomStyles = {
    popup: {
        default: {
            overflowY: 'hidden',
        },
    },
};

interface IProps {
    isOpen: boolean,
    onClose: () => void,

    className?: string,
}

/**
 * Попап с предложением скачать мобильное приложение
 *
 * В десктопной версии отображается QR-код для скачивания МП.
 *
 * В мобильной версии отображается кнопка, при нажатии на которую пользователя редиректит на страницу скачивания МП.
 */
const MobileAppPopup = ({ isOpen, onClose, className }: IProps): JSX.Element => {
    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);

    const downloadHandler = () => {
        mobileAppPopupAnalytics.downloadApp();
    };

    return (
        <DefaultPopup isOpen={isOpen} onClose={onClose} customStyles={customStyles} className={className}>
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <FullWidthListContainer $direction={'column'} $wrap={'nowrap'} $size={16}>
                    <TextWrapper $lastIndent={false}>
                        <H3>
                            &laquo;Мой Дом.ру&raquo; всегда под рукой
                        </H3>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            Все ваши услуги и&nbsp;чат с&nbsp;техподдержкой в&nbsp;одном приложении.
                        </Paragraph4>
                    </TextWrapper>

                    {isTablet && (
                        <ButtonGroup>
                            <a href='https://app.dom.ru/company' target='_blank' rel='noopener noreferrer'>
                                <Button
                                    bType='secondary'
                                    Icon={<ImportSquare/>}
                                    onClick={downloadHandler}
                                    data-test='download-btn'
                                >
                                    Скачать приложение
                                </Button>
                            </a>
                        </ButtonGroup>
                    )}
                </FullWidthListContainer>
            </IndentContainer>

            <NonStaticContainer $united={{ $zIndex: -1 }}>
                <WebpImage urlWebp={isTablet ? MobileBannerWebp : DesktopBannerWebp}>
                    <img src={isTablet ? MobileBanner : DesktopBanner} alt=''/>
                </WebpImage>
            </NonStaticContainer>
        </DefaultPopup>
    );
};

export default styled(MobileAppPopup)`
    ${TextWrapper} {
        max-width: 290px;
    }

    ${NonStaticContainer} {
        bottom: 0;
        right: 70px;
        width: 196px;
        height: 148px;

        img,
        picture {
            width: 100%;
            height: 100%;
            object-position: center;
            object-fit: contain;
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${NonStaticContainer} {
            bottom: 37px;
            right: 0;
            width: 100px;
            height: 126px;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${TextWrapper} {
            max-width: 245px;
        }
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        ${TextWrapper} {
            max-width: 200px;
        }
    }
`;
